import { render, staticRenderFns } from "./SelectUf.vue?vue&type=template&id=d7a897ac&"
import script from "./SelectUf.vue?vue&type=script&lang=js&"
export * from "./SelectUf.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports